/**
 * /jobs/:id — which job page this person sees (threads/job-page-fresh, 10/28).
 *
 * The per-person switch (`job-page.finish-line`, lib/finish-line.ts) used to
 * open the "new" page inside detail.tsx. It now opens the page rebuilt from a
 * clean sheet (fresh/fresh-job-page.tsx). The classic page is unchanged and
 * stays the default. `?page=classic` shows the classic page once without
 * touching the switch (the new page's links to tools it doesn't have yet).
 */
import { useParams, useSearchParams } from "react-router-dom";
import { useFinishLineSwitch } from "@/lib/finish-line";
import JobDetailPage from "./detail";
import FreshJobPage from "./fresh/fresh-job-page";
import { FreshNotice } from "./fresh/fresh-notice";

export default function JobPageRouter() {
    const { id } = useParams<{ id: string }>();
    const [params] = useSearchParams();
    const sw = useFinishLineSwitch();
    if (sw.on && params.get("page") !== "classic") return <FreshJobPage key={id} />;
    return (
        <>
            {!sw.on && (
                <div className="mb-3">
                    <FreshNotice mode="classic" />
                </div>
            )}
            <JobDetailPage key={id} />
        </>
    );
}
